import React from 'react';

const GettingStart = () => {
  return (
    <div className='bg-themeColor w-full'>
      <h3 className='font-popinsBold text-6xl text-white text-center'>Getting Started</h3>
      <div className='flex'>
        <div className='w-[49%] bg-white'></div>
        <div className='w-[49%] bg-white'></div>
      </div>
    </div>
  );
};

export default GettingStart;
